var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYsq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 36,
    viewBox: "0 0 130 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tags"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39854",
    d: "M4.61651e-05 0H112.32C122.084 0 130 7.91582 130 17.6805V17.6805C130 27.4451 122.084 35.3609 112.32 35.3609H0L4.61651e-05 0Z",
    fill: "#E7F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xB7\xB2\xE7\x94\xB3\xE8\xAF\xB7",
    d: "M22.08 13.306V20.794C22.08 23.242 23.024 23.85 26.128 23.85C26.848 23.85 30.688 23.85 31.472 23.85C34.4 23.85 35.104 22.97 35.472 19.93C34.912 19.834 34.016 19.498 33.52 19.178C33.296 21.53 33.04 21.946 31.392 21.946C30.448 21.946 26.944 21.946 26.112 21.946C24.336 21.946 24.064 21.786 24.064 20.794V13.306H22.08ZM23.232 15.482V17.386H32.08V15.482H23.232ZM21.44 10.17V12.074H31.36V18.122H33.36V10.17H21.44ZM37.552 11.402V21.018H39.456V13.242H48.528V20.922H50.528V11.402H37.552ZM38.8 14.874V16.634H49.472V14.874H38.8ZM38.8 18.33V20.17H49.504V18.33H38.8ZM42.944 9.274V24.298H44.944V9.274H42.944ZM53.28 10.666C54.144 11.45 55.28 12.554 55.776 13.258L57.088 11.93C56.544 11.242 55.376 10.218 54.512 9.498L53.28 10.666ZM54.608 24.138C54.896 23.754 55.424 23.306 58.336 21.034C58.128 20.65 57.84 19.898 57.712 19.386L54.576 21.77L54.192 22.378L54.608 24.138ZM52.544 14.202V16.042H55.696V14.202H52.544ZM54.608 24.138C54.608 23.466 56.336 22.298 56.336 22.298V14.202H54.496V21.002C54.496 21.738 54.032 22.282 53.68 22.522C54 22.89 54.464 23.69 54.608 24.138ZM60.064 18.554V19.786H64.992V18.554H60.064ZM58.016 10.362V11.738H66.976V10.362H58.016ZM58.448 12.378V13.674H66.496V12.378H58.448ZM57.52 14.346V15.722H67.488V14.346H57.52ZM60.032 20.682V21.962H64.976V20.682H60.032ZM58.608 16.346V24.314H60.384V17.738H64.96V16.346H58.608ZM64.56 16.346V22.426C64.56 22.618 64.48 22.682 64.272 22.682C64.064 22.698 63.296 22.698 62.64 22.666C62.864 23.114 63.088 23.818 63.152 24.298C64.272 24.298 65.072 24.282 65.632 24.01C66.224 23.754 66.384 23.29 66.384 22.458V16.346H64.56ZM61.504 9.274V14.794H63.408V9.274H61.504Z",
    fill: "#3E7EFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 65",
    cx: 112,
    cy: 17.6805,
    rx: 14,
    ry: 13.7515,
    fill: "#3E7EFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wodeziliao_stateicon_yishenqing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39857",
    d: "M117.25 10.787V10.787C118.216 10.787 119 11.5705 119 12.537V22.787C119 23.8916 118.105 24.787 117 24.787H107C105.895 24.787 105 23.8916 105 22.787V12.537C105 11.5705 105.784 10.787 106.75 10.787V10.787",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M109.5 18.287L111.5 20.287L115 16.787",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39858",
    x: 109,
    y: 8.84024,
    width: 6,
    height: 2.94675,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYsq);
export default __webpack_public_path__ + "static/media/ysq.22345d2c2060a98f7ac02a535fb66d45.svg";
export { ForwardRef as ReactComponent };